import React from 'react';
import OptimizeModal from '../OptimizeModal.js';
import withDerModal from '../../../common/withDerModal.js';

function DERTrackingModal({ setDerModal, derModal }) {
  const onClickYes = () => {
    setDerModal({ ...derModal, show: false, answer: 'Yes' });
  };

  const onClickNo = () => {
    setDerModal({ ...derModal, show: false, answer: 'No' });
  };

  return (
    <OptimizeModal
      show={derModal.show} id="der-tracking-modal"
      modalBody={(
        <div>
          <p style={{ marginBottom: 0 }}>Are J&J MedTech products being revised?</p>
          <p style={{ marginBottom: 0 }}>If Yes, a DER is required.</p>
        </div>
      )}
      modalFooter={(
        // <div style={{ display: 'flex', margin: 0 }}>
        //   <a
        //     role="button"
        //     tabIndex={0}
        //     style={{
        //       flex: 1,
        //       display: 'flex',
        //       justifyContent: 'center',
        //       alignItems: 'center',
        //       padding: '10px 0',
        //       color: '#2c7ce7'
        //     }}
        //     onClick={() => {
        //       setDerModal({ ...derModal, show: false, answer: 'No' });
        //     }}
        //   >
        //     No
        //   </a>
        //   <a
        //     role="button"
        //     tabIndex={0}
        //     style={{
        //       flex: 1,
        //       display: 'flex',
        //       justifyContent: 'center',
        //       alignItems: 'center',
        //       borderLeft: '1px solid #424242',
        //       color: '#2c7ce7'
        //     }}
        //     onClick={() => {
        //       setDerModal({ ...derModal, show: false, answer: 'Yes' });
        //     }}
        //   >
        //     Yes
        //   </a>
        // </div>
        <div className="row gx-2">
          <div className="col-6">
            <button
              type="button" className="btn btn-gray w-100"
              data-bs-dismiss="modal"
              onClick={() => onClickNo()}
            >
              No
            </button>
          </div>
          <div className="col-6">
            <button
              type="button" className="btn btn-gray w-100"
              data-bs-dismiss="modal"
              onClick={() => onClickYes()}
            >
              Yes
            </button>
          </div>
        </div>
      )}
    />
  );
}

export default withDerModal(
  DERTrackingModal
);
